export function intersects(lhs, rhs) {
    const top = Math.max(lhs.top, rhs.top);
    const left = Math.max(lhs.left, rhs.left);
    const bottom = Math.min(lhs.bottom, rhs.bottom);
    const right = Math.min(lhs.right, rhs.right);
    return left < right && top < bottom;
}
export function union(lhs, rhs) {
    const top = Math.min(lhs.top, rhs.top);
    const left = Math.min(lhs.left, rhs.left);
    const bottom = Math.max(lhs.bottom, rhs.bottom);
    const right = Math.max(lhs.right, rhs.right);
    return { top, left, bottom, right };
}
export function isOnScreen(rect) {
    return intersects(rect, { top: 0, left: 0, right: window.innerWidth, bottom: window.innerHeight });
}
